import { render, staticRenderFns } from "./PageServicePass.vue?vue&type=template&id=12f0a8aa&"
import script from "./PageServicePass.vue?vue&type=script&lang=js&"
export * from "./PageServicePass.vue?vue&type=script&lang=js&"
import style0 from "./PageServicePass.vue?vue&type=style&index=0&id=12f0a8aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports